import React, { useState, useEffect } from 'react';
import SidePostGroupSub from './SidePostGroupSub';
import {categoryListApiAsync} from '../../api/api';

// Mock 分類數據
import categoriesData from '../../mockData/categories.json';

const SidePostGroup = () => {
    const [posts, setPosts] = useState([]);
    const [useMock, setUseMock] = useState(false); // Mock 開關狀態 - 手動修改此處來控制

    // 初始和分頁加載數據
    useEffect(() => {
        // 如果啟用 Mock 模式，使用 Mock 數據
        if (useMock) {
            setPosts(categoriesData);
            return;
        }

        // 使用真實 API
        categoryListApiAsync().then((response) => {
            if (response.length > 0) {
                setPosts(response);
            }
        });
    }, [useMock]);

    // 計算總文章數
    const totalPosts = posts.reduce((sum, category) => sum + category.postCount, 0);

    return (
        <div className='mb-5 content-main'>
            <div className='categories-header'>
                <div className='categories-title-container'>
                    <svg className='categories-icon' viewBox="0 0 24 24" fill="currentColor">
                        <path d="M10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z" />
                    </svg>
                    <h4 className='categories-title'>文章分類</h4>
                </div>
                <div className='categories-stats'>
                    <div className='categories-count'>{posts.length}</div>
                    <div className='categories-total'>{totalPosts} 篇</div>
                </div>
            </div>

            <div className='categories-container'>
                {posts.map((post) => (
                    <SidePostGroupSub key={post.categoryId} posts={post} />
                ))}
            </div>
        </div>
    );
};

export default SidePostGroup;